import ENDPOINTS from '../../const/endpoints';
export var eligibilityCacheKey = function (props) {
    return [ENDPOINTS.refundEligibility, props];
};
